<template>
  <transition name="modal">
    
    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">
        
        <em class="sa-icon sa-info icon-exclamation"></em>
        <h2 class="modal-title ">Suggested address</h2>
        <p class="modal-subtitle">We’ve found the following address given the details you provided:</p>
        
          <p class="modal-paragraph"> {{suggestedAddress.streetAddress1}}<br>
            <span v-if="suggestedAddress.streetAddress2">{{suggestedAddress.streetAddress2}} <br></span>
            {{suggestedAddress.city}}, {{suggestedAddress.state}} {{suggestedAddress.zipCode}}
          </p>

        <div class="modal-buttons">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-center">
                  <p>Would you like to accept or edit the address?</p>
                  <button type="submit" class="btn btn-info btn-lg btn-cancel" @click="closeModal()">Go back to edit</button>
                  <button type="submit" class="btn btn-info btn-lg btn-accept" @click="acceptSuggestion()">Accept suggestion</button>
                </div>
              </div>
            </slot>
          </div>

      </div>
      <!-- End of New Modal -->
    </div>
  </transition>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex';
  import {
    SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
    SET_CHANGE_ADDRESS,
  } from '@/store/mutation-types';

  export default {
    name: 'addressSuggestion',
    computed: {
      ...mapState('app', [
        'user',
      ]),
      ...mapState('accountCreation', [
        'suggestedAddress',
        'suggestedAddressType',
        'methodForYesButton',
        'userByAdmin',
      ]),
    },
    methods: {
      ...mapMutations('accountCreation', {
        setSuggestedAddressModalVisible: SET_SUGGESTED_ADDRESS_MODAL_VISIBLE,
        setChangeAddress: SET_CHANGE_ADDRESS,
      }),
      acceptSuggestion() {
        this.setChangeAddress(true);
        if (Object.keys(this.userByAdmin).length > 0) {
          this.userByAdmin[`${this.suggestedAddressType}Address`] = Object.assign({}, this.suggestedAddress);
        } else {
          this.user[`${this.suggestedAddressType}Address`] = Object.assign({}, this.suggestedAddress);
        }
        this.methodForYesButton();
        this.closeModal();
      },
      closeModal() {
        this.setChangeAddress(false);
        this.setSuggestedAddressModalVisible(false);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal-buttons {
    border-top: 1px solid #e5e5e5;
    padding: 15px;
    margin-top: 40px;
  }
  .modal-buttons p {
    margin-bottom: 20px;
  }
  .modal-wrapper p {
    font-size: 16px;
    text-align: center; 
  }
  .modal-title {
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// AddressSuggestion.vue?d2fa136e